const accordions = document.querySelectorAll("[data-faq-accordion]");

accordions.forEach((accordion) => {
  const items = accordion.querySelectorAll("[data-faq-item]");
  const triggers = accordion.querySelectorAll("[data-faq-trigger]");

  triggers.forEach((trigger, index) => {
    const currentItem = items[index];
    const content = currentItem.querySelector("[data-faq-content]");
    const inner = content.querySelector(".faq-answer-inner");

    trigger.addEventListener("click", function () {
      const isActive = currentItem.classList.contains("active");

      items.forEach((item, i) => {
        const itemContent = item.querySelector("[data-faq-content]");
        item.classList.remove("active");
        itemContent.style.height = "0px";
      });

      if (!isActive) {
        currentItem.classList.add("active");
        const height = inner.offsetHeight;
        content.style.height = height + "px";
      }
    });
  });

  if (items.length > 0) {
    const firstItem = items[0];
    const firstContent = firstItem.querySelector("[data-faq-content]");
    const firstInner = firstContent.querySelector(".faq-answer-inner");

    firstItem.classList.add("active");
    firstContent.style.height = firstInner.offsetHeight + "px";
  }

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      items.forEach((item) => {
        if (item.classList.contains("active")) {
          const content = item.querySelector("[data-faq-content]");
          const inner = content.querySelector(".faq-answer-inner");
          content.style.height = inner.offsetHeight + "px";
        }
      });
    }, 250);
  });
});